/* eslint-disable max-len */
import React from 'react'

export default function Emptyscreenwithouttitle({FirstPTag,SecondePTag,title,classKey,customHeight,noPatientdashboardHeight}) {
    return (
        <>
            <div className={`bg-white rounded-lg py-3 px-6 ${classKey !== undefined ? '' : customHeight === undefined ? (noPatientdashboardHeight ? 'h-[calc(100vh-200px)]' : 'h-customh7') : `${customHeight === false ? 'h-auto' : 'h-customh11'}`} flex flex-col justify-center items-center`}>
                <img src="/images/emptyscreen_img.png" alt="emptyscreen" className={`mx-auto`}/>
                <p id= "empty_screen" className="text-center text-xl font-normsl text-[#000]">{FirstPTag} <br />{SecondePTag}</p>
            </div>
           
        </>

       
    )
}
